const $inject = ['$scope', '$routeParams', 'dataService','$timeout'];

const lbaEnhancedLogItemCtrl = function ($scope, $routeParams, dataService,$timeout) {
    const vm = this;
    vm.item = dataService.data.activeItem;
    vm.ShowPanel = ShowPanel;
    vm.gotoNext = function(next){
        if(dataService.data.gotoNext) dataService.data.gotoNext(next);
    }
    $scope.$watch(() => dataService.data.activeItem, () => {
        vm.item = dataService.data.activeItem;
        formatData();
    });
    
    $timeout(() => {
          $( "#tabsRequest" ).tabs();
          $( "#tabsResponse" ).tabs();
      });
      function formatData(){
        vm.formattedRequest = null;
        vm.formattedResponse = null;
        if(!vm.item){
            return;
        }
        vm.formattedRequest = prettyPrint(vm.item.RequestMessage);
        vm.formattedResponse = prettyPrint(vm.item.ResponseMessage);
        if(vm.item.LinkedId){
          let linkedItems = dataService.data.items.filter(d=>d.LinkedId===vm.item.LinkedId);
          linkedItems.sort((a,b)=>a.LinkedIndex-b.LinkedIndex);
          if(linkedItems.length){
            let rq= '';
            let rs= '';
            linkedItems.forEach(item=>{
              if(item.RequestMessage){
                rq += item.RequestMessage;
              }
              if(item.ResponseMessage){
                rs += item.ResponseMessage;
              }
           
            });
            vm.formattedRequest = prettyPrint(rq);
            vm.formattedResponse = prettyPrint(rs);
          }
        }
       
      }
      function prettyPrint(value){
        
        let pretty = prettyJson(value);
        if(pretty!=null) return pretty;
        pretty = prettyXml(value);
        if(pretty!=null) return pretty;
        return value;
      }
      function prettyJson(value){
        try{
            var obj = JSON.parse(value);
            return JSON.stringify(obj, undefined, 4);
        }catch(e){}
        return null;
      }
      function prettyXml(sourceXml){
        try{
            var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
            var xsltDoc = new DOMParser().parseFromString([
                // describes how we want to modify the XML - indent everything
                '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
                '  <xsl:strip-space elements="*"/>',
                '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
                '    <xsl:value-of select="normalize-space(.)"/>',
                '  </xsl:template>',
                '  <xsl:template match="node()|@*">',
                '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
                '  </xsl:template>',
                '  <xsl:output indent="yes"/>',
                '</xsl:stylesheet>',
            ].join('\n'), 'application/xml');

            var xsltProcessor = new XSLTProcessor();    
            xsltProcessor.importStylesheet(xsltDoc);
            var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
            var resultXml = new XMLSerializer().serializeToString(resultDoc);
            if(resultXml.indexOf('Below is a rendering of the page up to the first error.')>-1){
                return null;
            }
            return resultXml;
        }catch(e){}
        return null;
      }
      function ShowPanel(panel,panelParent,panelDialog,popupButton){
        let element = $("#" + panel).detach();
        $("#" + panelDialog).append(element);
        $("#" + popupButton).hide();
        $( "#" + panelDialog ).dialog({
          resizable: true,
          height: 400,
          width: 400,
          close: function(){
            element = $("#" + panel).detach();
            $("#" + panelParent).append(element);
            $("#" + popupButton).show();
          }
        });
      }
};

lbaEnhancedLogItemCtrl.$inject = $inject;

export default lbaEnhancedLogItemCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaEnhancedLogItem/lbaEnhancedLogItemCtrl.js